<ng-template #displayTemplateRef
             let-rowData="rowData">
  @if (loadingItems.has(rowData.id)) {
    <p-progressSpinner class="sc-spinner-small">
    </p-progressSpinner>
  } @else {
    <a scOverflowTooltip
       href="#"
       (click)="showReport(rowData)">
      {{ getLinkText(rowData) }}
    </a>
  }
</ng-template>